import React, { useState } from 'react';
import * as styles from './valuesSection.module.scss';
import { usePageContext } from '../context/pageContext';
import { SanityValuesSection } from 'graphql-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Button } from '../html-tag/Button';
import { CTA } from '../html-tag/Cta';
import { graphql, useStaticQuery } from 'gatsby';
import { Carousel } from '../ui/carousel/Carousel';
import { SwiperSlide } from 'swiper/react';
import Swiper from 'swiper';
import { Blocks } from '../ui/blocks/Blocks';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityValuesSection;
}

export const ValuesSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  const valueButton = useStaticQuery(VALUE);
  const [active, setActive] = useState<number>(-1);
  const [swiper, setSwiper] = useState<Swiper>();

  return (
    <div className={styles.wrapper}>
      {section?.activeLogo && (
        <div className={styles.image}>
          <GatsbyImage
            image={section?.valuesLogoSection?.logoImg?.asset?.gatsbyImageData ?? ''}
            alt={section?.valuesLogoSection?.logoAlt ?? ''}
          />
        </div>
      )}
      {section?.activeText && (
        <div className={styles.text}>
          <Blocks blocks={findTranslation(section?._rawValuesTextSection, lang, defaultLang)} />
        </div>
      )}

      {section?.activeMap && (
        <>
          <div className={styles.map}>
            {/* <WorldMap active={active} setActive={setActive} list={section?.locationsMap} /> */}
            <GatsbyImage
              image={section?.imgMap?.img?.asset?.gatsbyImageData}
              alt={section?.imgMap?.alt ?? ''}
            />
            {section?.locationsMap?.map((card, index) => (
              <>
                {active === index && (
                  <div
                    className={styles.card}
                    key={`card-${index}`}
                    data-country={card?.countryLocation}
                  >
                    <div className={styles.image}>
                      <GatsbyImage
                        image={card?.imgLocation?.img?.asset?.gatsbyImageData}
                        alt={card?.imgLocation?.alt ?? ''}
                      />
                    </div>
                    <h2>{findTranslation(card?._rawTitleLocation, lang, defaultLang)}</h2>
                    <Blocks blocks={findTranslation(card?._rawTextLocation, lang, defaultLang)} />
                    <div className={styles.triangle} />
                  </div>
                )}
              </>
            ))}
          </div>
          <div className={styles.buttons}>
            <Carousel setSwiper={setSwiper}>
              {section?.locationsMap?.map((location, index) => (
                <SwiperSlide
                  key={`button-${location?.countryLocation}`}
                  style={{ width: 'fit-content' }}
                >
                  <Button
                    label={location?.countryLocation?.toUpperCase() ?? ''}
                    dataType={active === index ? 'orange' : ''}
                    key={`location-${index}`}
                    onClick={() => setActive(active === index ? -1 : index)}
                  />
                </SwiperSlide>
              ))}
            </Carousel>
          </div>
          <div className={styles.buttonsDesktop}>
            {section?.locationsMap?.map((location, index) => (
              <Button
                label={location?.countryLocation?.toUpperCase() ?? ''}
                dataType={active === index ? 'orange' : ''}
                key={`location-${index}`}
                onClick={() => setActive(active === index ? -1 : index)}
                style={{ minWidth: '150px' }}
              />
            ))}
          </div>
        </>
      )}

      <div className={styles.value}>
        {section?.valuesListNumberSection?.map((valueNumber, index) => {
          return (
            <div
              className={`${styles.valueNumber} ${
                section?.valuesListNumberSection?.length === 3 && styles.valueNumber3
              }`}
              key={`valueSection-${index}`}
            >
              <div>{valueNumber?.number}</div>
              <h4>{findTranslation(valueNumber?._rawTitle, lang, defaultLang)}</h4>
            </div>
          );
        })}
      </div>

      {section?.activeButton && (
        <div className={styles.button}>
          <CTA
            label={findTranslation(
              valueButton?.sanityFunctionButton?._rawAcademy,
              lang,
              defaultLang,
            )}
            onClick={() => {}}
            dataType={'orangewhite'}
            to={''}
          />
        </div>
      )}
    </div>
  );
};

export const VALUE = graphql`
  query Value {
    sanityFunctionButton {
      _rawAcademy(resolveReferences: { maxDepth: 10 })
    }
  }
`;
